var KEYBOARD_KEYNAMES = /*#__PURE__*/function (KEYBOARD_KEYNAMES) {
  KEYBOARD_KEYNAMES["ENTER"] = "Enter";
  KEYBOARD_KEYNAMES["SPACE"] = " ";
  KEYBOARD_KEYNAMES["TAB"] = "Tab";
  KEYBOARD_KEYNAMES["ESCAPE"] = "Escape";
  KEYBOARD_KEYNAMES["ARROW_DOWN"] = "ArrowDown";
  KEYBOARD_KEYNAMES["ARROW_LEFT"] = "ArrowLeft";
  KEYBOARD_KEYNAMES["ARROW_RIGHT"] = "ArrowRight";
  KEYBOARD_KEYNAMES["ARROW_UP"] = "ArrowUp";
  KEYBOARD_KEYNAMES["END"] = "End";
  KEYBOARD_KEYNAMES["HOME"] = "Home";
  KEYBOARD_KEYNAMES["PAGE_DOWN"] = "PageDown";
  KEYBOARD_KEYNAMES["PAGE_UP"] = "PageUp";
  return KEYBOARD_KEYNAMES;
}(KEYBOARD_KEYNAMES || {});

export { KEYBOARD_KEYNAMES as K };
//# sourceMappingURL=keyboardKeynames-AmBipDtf.js.map
